/**
 * UI/UX 개편(uiux-renewal) 공용 목 데이터 — 서버 API가 아직 없는 화면(미션/시즌
 * 대시보드/소각/재매입/자산 출금/지갑 원장/상점 박스)의 표시용 값.
 * 규약: 이 파일은 그룹 공용 읽기 전용 — 화면별 목 로직은 각 도메인 파일
 * (missions.ts, shop.ts, cardActions.ts, wallet.ts …)에 두고 여기서는 공유
 * 상수·기본 시나리오만 관리한다.
 * TODO(server): 각 값은 대응 RPC가 생기는 즉시 서버 값으로 교체 — 하드코딩 금지
 * 항목(확률·잔여 수량·기준 시세·재매입 비율)은 전부 여기 모아 추적한다.
 */

export const MOCK_LATENCY_MS = 350;

export function mockDelay(ms: number = MOCK_LATENCY_MS): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** §2.1.2 Burn & Exchange 환산 규칙 — 스펙 확정값 (서버 검증은 별도) */
export const CARD_UNITS = { base: 1, holo: 5, packCost: 100 } as const;

/** §2.3.1 RP 기준 가치 — 참고 병기용 (R-19: 충전 화면 등 제한적 병기) */
export const RP_PER_USDT = 100;

/** §2.3.4 재매입 비율 범위 — 실제 비율은 서버 값 (mock은 85%) */
export const BUYBACK_RATE_RANGE = { min: 0.8, max: 0.9, mock: 0.85 } as const;

/** §5.5.4 일일 무료 팩 한도 */
export const DAILY_PACK_CAP = 20;

/** §6.5 10-Tier 분류 (순위 비율 기준) — 시즌 대시보드 표시용 */
export type SeasonTier = { tier: number; label: string; topPercent: number };
export const SEASON_TIERS: SeasonTier[] = [
  { tier: 1, label: "Tier 1", topPercent: 1 },
  { tier: 2, label: "Tier 2", topPercent: 3 },
  { tier: 3, label: "Tier 3", topPercent: 5 },
  { tier: 4, label: "Tier 4", topPercent: 10 },
  { tier: 5, label: "Tier 5", topPercent: 20 },
  { tier: 6, label: "Tier 6", topPercent: 35 },
  { tier: 7, label: "Tier 7", topPercent: 50 },
  { tier: 8, label: "Tier 8", topPercent: 70 },
  { tier: 9, label: "Tier 9", topPercent: 90 },
  { tier: 10, label: "Tier 10", topPercent: 100 },
];

/** KYC 상태 머신 (§2.5.2 Step 6C) */
export type KycStatus = "none" | "pending" | "verified" | "rejected";

/** 자산 출금 진행 상태 (R-12: 신청→처리→전송→소각) */
export type RedemptionStage = "requested" | "processing" | "transferred" | "burned";
